import BasketProductItem from './BasketProductItem';

export default BasketProductItem;
